class Validate {
  email = {
    reg: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
    msg: "请输入正确的邮箱地址"
  };
  phone = {
    // 联系方式
    reg: /^[\d-]{1,20}$/,
    msg: "联系方式只能包含数字跟横线"
  };
  mobile = {
    //手机号
    reg: /^1\d{10}$/,
    msg: "请输入正确的手机号"
  };
  name = {
    //姓名
    reg: /^[a-zA-Z\u4e00-\u9fa5]+$/,
    msg: "只能是中文或英文"
  };
  username = {
    //  账号
    reg: /^[a-zA-Z][a-zA-Z0-9_]*$/,
    msg: "只能英文、数字、或下划线，且英文开头"
  };
  test(type, val) {
    return this[type].reg instanceof RegExp
      ? this[type].reg.test(val)
      : this[type].reg(val);
  }
  Validate(type) {
    return (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (this.test(type, value)) return callback();
      callback(new Error(this[type].msg));
    };
  }
}

export default new Validate();
